import {
  collection,
  doc,
  setDoc,
  getDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  Timestamp,
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { LaborRate } from '../types';

export class LaborService {
  static async createLaborRate(rate: Omit<LaborRate, 'id'>): Promise<LaborRate> {
    try {
      const rateRef = doc(collection(db, 'laborRates'));

      const rateData: any = {
        ...rate,
        createdAt: Timestamp.now(),
      };

      await setDoc(rateRef, rateData);

      return {
        ...rate,
        id: rateRef.id,
      };
    } catch (error: any) {
      throw new Error(`Failed to create labor rate: ${error.message}`);
    }
  }

  static async getLaborRate(id: string): Promise<LaborRate | null> {
    try {
      const docSnap = await getDoc(doc(db, 'laborRates', id));
      if (docSnap.exists()) {
        return { ...docSnap.data(), id: docSnap.id } as LaborRate;
      }
      return null;
    } catch (error: any) {
      throw new Error(`Failed to get labor rate: ${error.message}`);
    }
  }

  static async getAllLaborRates(): Promise<LaborRate[]> {
    try {
      const q = query(collection(db, 'laborRates'), orderBy('order', 'asc'));
      const querySnap = await getDocs(q);
      return querySnap.docs.map((doc) => ({
        ...doc.data(),
        id: doc.id,
      } as LaborRate));
    } catch (error: any) {
      throw new Error(`Failed to get labor rates: ${error.message}`);
    }
  }

  static async updateLaborRate(id: string, updates: Partial<LaborRate>): Promise<void> {
    try {
      const { id: _id, ...dataToUpdate } = updates as any;
      await updateDoc(doc(db, 'laborRates', id), {
        ...dataToUpdate,
        updatedAt: Timestamp.now(),
      });
    } catch (error: any) {
      throw new Error(`Failed to update labor rate: ${error.message}`);
    }
  }

  static async deleteLaborRate(id: string): Promise<void> {
    try {
      await deleteDoc(doc(db, 'laborRates', id));
    } catch (error: any) {
      throw new Error(`Failed to delete labor rate: ${error.message}`);
    }
  }
}
